import "./styles/gauge.css";
function Gauge({
  value,
  label,
  size = 51,
  strokeWidth = 5,
  circleOneStroke = "#f0f0f0d2",
}) {
  const halfSize = size / 2;
  const radius = halfSize - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - value / 100);

  const getStrokeColor = (value) => {
    if (value <= 25) {
      return "rgb(217, 18, 18)";
    } else if (value <= 50) {
      return "rgb(226, 153, 34)";
    } else if (value <= 75) {
      return "rgb(227, 227, 23)";
    } else {
      return "rgb(19, 201, 19)";
    }
  };
  const strokeColor = getStrokeColor(value);
  return (
    <div className="gauge-chart" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          className="gauge-circle-bg"
          cx={halfSize}
          cy={halfSize}
          r={radius}
          fill="none"
          stroke={circleOneStroke}
          strokeWidth={strokeWidth}
        />
        <circle
          className="gauge-circle"
          cx={halfSize}
          cy={halfSize}
          r={radius}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="butt"
          transform={`rotate(-90 ${halfSize} ${halfSize})`}
        />
      </svg>

      <div className="gauge-center">
        <div className="gauge-value">{value}%</div>
      </div>
    </div>
  );
}

export default Gauge;
